var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"main pt-3 bg-light"},[_c('pages-tab-navigation',{attrs:{"routes":_vm.routeLinks}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }